export const LangText: any = {
    us: {
        product_name: 'EcoFlow OCEAN Pro',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Be the First to Know',
        btn_consultatio: 'Start Your Free Consultation',
    },
};
